export default __webpack_public_path__ + "static/media/loading-progress.6230087d.svg";